import { InMemoryCache } from '@apollo/client';

/**
 * Several types are values rather than entities: an embedded profile, a
 * submission held on its assignment record, a page of results. They have no
 * `id`, so Apollo would warn and fall back to storing them by path anyway —
 * `keyFields: false` says so deliberately, and keeps them attached to their
 * parent where they belong.
 */
const embedded = { keyFields: false };

export default new InMemoryCache({
  possibleTypes: {},
  typePolicies: {
    StudentProfile: embedded,
    TeacherProfile: embedded,
    Submission: embedded,
    StatsType: embedded,
    UserPage: embedded,
    UploadTicket: embedded,
    AuthPayload: embedded,

    /**
     * Per-student records are addressed by activity and user together; the
     * `id` field is only the user id, which repeats across activities.
     */
    StudentActivity: { keyFields: ['activityId', 'userId'] },

    Upload: {
      fields: {
        // Signed and short-lived, so a cached one goes stale. Always take
        // the value from the most recent response.
        url: { merge: (_existing, incoming) => incoming },
      },
    },
  },
});
